import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../../stateProvider/StateProvider';
import PageBreak from '../../../layout/PageBreak';
import FormSetting from '../../../layout/FormSetting';
import HamQuest from '../../../api/HamQuestGiver';
import Input from '../../../forms/Input';
import Select from '../../../forms/Select';
import { HSOptions } from '../../../../constants/HSOptions';
import Checkbox from '../../../forms/Checkbox';
import Button from '../../../forms/Button';
import Table from '../../../table/Table';
import { generateId, shortHandDate, shortHandDateTime, translate } from '../../../utility/functions';
import GetState from '../../../GetState';
import Loading from '../../../Loading';
import Page from '../../../layout/Page';
import Form from '../../../forms/Form';
import ManagementRow from '../../../table/ManagementRow';
import PhoneNumberInput from '../../../forms/formComponents/PhoneNumberInput';
import ModalFactory from '../../../Modal';
import Audit from '../Audit';
import Row from '../../../layout/Row';
import KioskErrorResponses from '../../reporting/KioskErrorResponses';
import { userRoles } from '../../../RoleProtected';
import UpgradeAndAutoSelect from '../../../forms/formComponents/UpgradeAndAutoSelect';

const LoyaltyMember = ({ userData, ...props }) => {
    const types = {
        LP: 'LicensePlate',
        RF: 'RFID',
        App: 'AppId',
    };

    const {
        state: {
            states,
            locations
        },
    } = useGlobalState();

    const { loyaltyMemberId } = useParams();

    const [member, refreshMember] = GetState(QuestRoute.loyaltyUser.member(loyaltyMemberId));

    if (!member) return <Loading page />;

    const passMaxUses = [{ label: 'Account Default', value: 'UseDefault' }, ...HSOptions.expressPass.maxUsePeriod];
    const receiptMode = [{ label: 'Account Default', value: 'UseDefault' }, ...HSOptions.expressPass.receiptMode];

    const deleteMedia = (media) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'Are you sure?',
                body: 'Are you sure you want to delete this Media ID?',
                type: 'warning',
                slideToAccept: true,
            },
            promise: {
                title: 'Removing Media ID',
                callback: () => HamQuest.delete(QuestRoute.user.mediaID(member.customerId, media.id))
            },
            confirmed: {
                title: 'Media Deleted',
                type: 'success',
            },
            finally: () => refreshMember()
        })
    }

    const editMedia = (media) => {
        // console.log(media)
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Editing Media`,
            body: (
                <Form
                    inputs={{
                        id: media.id,
                        mediaId: media.mediaId,
                        mediaType: media.mediaType,
                        tagType: media.tagType,
                        status: media.status
                    }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.user.mediaID(member.customerId, media.id), { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshMember()
                            })
                    )}
                >
                    {({ values }) => (
                        <>
                            <Input
                                name='mediaId'
                                label={'Media ID'}
                                sanitize={e => {
                                    if (values.mediaType !== types.LP) return e;
                                    return e.replace(/./g, (char) => char.toUpperCase())
                                }}
                                maxLength={values.mediaType === types.LP ? 8 : 100}
                                readOnly
                                required
                            />
                            <Select
                                name='status'
                                label='Status'
                                options={HSOptions.expressPass.status}
                                required
                            />
                        </>
                    )}
                </Form>
            )
        })
    }

    const addNewMedia = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `New Media`,
            body: (
                <Form
                    inputs={{
                        mediaType: 'RFID',
                        status: 'Active',
                        mediaId: '',
                    }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.user.mediaIDs(member.customerId), { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshMember()
                            })
                    )}
                >
                    {({ values }) => (
                        <>
                            <Select
                                name='mediaType'
                                label='Media Type'
                                options={HSOptions.user.media.types}

                                required
                            />

                            <Select
                                label='Status'
                                name='status'
                                options={HSOptions.user.media.status}
                                required
                            />

                            {values.mediaType === types.RF &&
                                <Select
                                    name='tagType'
                                    label='Tag Type'
                                    options={HSOptions.user.media.tags}
                                    required
                                />
                            }

                            {values.mediaType === types.LP &&
                                <Select
                                    label='State'
                                    name='state'
                                    options={states}
                                    required
                                />
                            }

                            {values.mediaType === types.RF &&
                                <Input
                                    label='RFID'
                                    value={values.tagType === 'Hamilton' ? '1026...' : 'AAA...'}
                                    disabled
                                    required
                                />
                            }

                            <Input
                                name='mediaId'
                                label='Media ID'
                                sanitize={e => {
                                    if (values.mediaType === types.LP) {
                                        return e
                                            .replace(/./g, (char) => char.toUpperCase())
                                            .replace(/[^a-z0-9]/gi, '');
                                    } else {
                                        return e.replace(/[^0-9]/gi, '');
                                    }
                                }}
                                maxLength={values.mediaType === types.LP ? 8 : 100}
                                required
                            />

                            {values.mediaType === types.LP &&
                                <Checkbox
                                    name='backupPlate'
                                    label='Backup Plate'
                                />
                            }
                        </>
                    )}
                </Form >
            )
        })
    }
    



    return (
        <Page
            title={member.contact.firstName + ' ' + member.contact.lastName}
            HSpage='loyalty_user'
            tabs
        >
            <PageBreak tab='Settings'>
                <FormSetting
                    label='Settings'
                    inputs={{ ...member }}
                    onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.member(loyaltyMemberId), { ...e })}
                    text='Update'
                    editable
                >
                    {({ values, editing }) => (
                        <>
                            <Select
                                label='Member Status'
                                name='status'
                                options={HSOptions.expressPass.status}
                                required
                            />
                            <Select
                                label='Loyalty Type'
                                name='loyaltyType'
                                getOptions={QuestRoute.products.loyaltyTypes}
                                required
                                disabled
                            />

                            <Row wrap>
                                <Select
                                    label='Award'
                                    name='awardId'
                                    getOptions={QuestRoute.expressPass.signupAwards + HamQuest.queryString({ loyaltyType: values.loyaltyType, loyaltyAccountId: member.loyaltyAccountId })}
                                    required
                                    nullable
                                />
                                <Input
                                    label='Package Price'
                                    name='packagePrice'
                                    type='price'
                                    disabled
                                    required
                                />
                            </Row>

                            {( member.loyaltyType != 'DailyPass' && member.loyaltyType != 'FleetPass'  )  && 
                                (<>
                                <Row align='flex-end' wrap>
                                    <Checkbox
                                        label='Use Custom Price'
                                        name='useCustomPrice'
                                    />
                                    <Input
                                        label='Custom Price'
                                        name='customPrice'
                                        type='price'
                                        disable={!values.useCustomPrice}
                                    />
                                </Row>
                            </> ) }

                            <Row wrap>
                                <Select
                                    label='Max Use Period'
                                    name='passMaxUsePeriod'
                                    options={passMaxUses}
                                    required
                                />
                                {(values.passMaxUsePeriod === 'Unlimited' || values.passMaxUsePeriod === 'UseDefault') ? (
                                    <Input
                                        label='Pass Max Uses'
                                        disabled
                                        required
                                    />
                                ) : (
                                <Input
                                    label='Pass Max Uses'
                                    name='passMaxUses'
                                    type='number'
                                    min={1}
                                    disabled = {values.passMaxUsePeriod === 'Unlimited' || values.passMaxUsePeriod === 'UseDefault' || editing}
                                    required
                                />
                            )}                            
                            </Row>

                            <Row align='flex-end' wrap>
                                <Checkbox
                                    label='Use Default Pass Reuse Time'
                                    name='useDefaultPassReuseTime'
                                />
                                {values.useDefaultPassReuseTime ? 
                                    <Input
                                        label='Pass Reuse Inhibit Time (min)'
                                        disabled
                                        required
                                    /> :
                                    <Input
                                        label='Pass Reuse Inhibit Time (min)'
                                        name='passReuseInhibitTime'
                                        type='number'
                                        disabled={values.useDefaultPassReuseTime || editing}
                                        required
                                    />
                                }
                            </Row>

                            <UpgradeAndAutoSelect autoSelectFieldName='autoSelect' />

                            <Select
                                label='Receipt Mode'
                                name='receiptMode'
                                options={receiptMode}
                                required
                            />
                        </>
                    )}
                </FormSetting>

                <FormSetting
                    label='Contact Info'
                    inputs={{ ...member.contact }}
                    onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.member(loyaltyMemberId), { ...e })}
                    text='Update'
                    editable
                >
                    {({ values }) => (
                        <>
                            <Input
                                label='First Name'
                                name='firstName'
                                required
                            />
                            <Input
                                label='Last Name'
                                name='lastName'
                                required
                            />
                            <PhoneNumberInput
                                name='phone'
                            />
                            <Input
                                label='Email'
                                name='email'
                                type='email'
                                required
                            />
                        </>
                    )}
                </FormSetting>
            </PageBreak>

            {/* <Audit tab='Audit Log' customerId={member.customerId} /> */}

            <Table
                tab='Media'
                config={{
                    data: member.media ?? [],
                    controls: [<Button onClick={addNewMedia}>Add New Media</Button>],
                    label: 'Member Media',
                    disableHeaderSearch: true,
                    headers: [
                        {
                            label: 'Type',
                            propKey: 'mediaType',
                            options: true,
                        }, {
                            label: 'ID',
                            propKey: 'mediaId',
                        }, {
                            label: 'status',
                            propKey: 'status',
                        },
                    ],
                    renderFormat: (e) => (
                        <ManagementRow
                            key={generateId()}
                            controls={[
                                <Button onClick={() => editMedia(e)} key={generateId()}>Edit</Button>,
                                <Button onClick={() => deleteMedia(e)} key={generateId()}>Delete</Button>
                            ]}
                        >
                            <td>{e.mediaType}</td>
                            <td>{e.mediaId}</td>
                            <td>{e.status}</td>
                        </ManagementRow>
                    )
                }}
            />

            <KioskErrorResponses 
                tab='Error Responses' 
                parentPage='LoyaltyMember'
                dataRoute={QuestRoute.user.kioskErrorResponseLog(member.customerId)}
                roles={userRoles.viewUsageReports} 
            />
            
        </Page>
    );
}

export default LoyaltyMember;
